var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.comment && this.comment.id
    ? _c(
        "div",
        {
          staticClass: "comment",
          class: { messagehidden: _vm.comment.is_hidden },
          attrs: { id: "`loadableContent-comment-${this.comment.id}`" },
        },
        [
          _c(
            "div",
            {
              class: _vm.getLinkedin
                ? "content-linkedin"
                : _vm.getInstagram
                ? "content-instagram"
                : "content",
            },
            [
              _c("div", { staticClass: "from-message" }, [
                _vm.comment.from &&
                (_vm.comment.from.name || _vm.comment.from.username)
                  ? _c("div", { staticClass: "from" }, [
                      _vm._v(
                        _vm._s(
                          _vm.comment.from.name || _vm.comment.from.username
                        ) + "\n      "
                      ),
                      _vm.page.network == "linkedin" &&
                      _vm.page.name == _vm.comment.from.name
                        ? _c("span", { staticClass: "autor-linkedin" }, [
                            _vm._v("Auteur"),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("div", {
                  staticClass: "message",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.colorizeBadWords(
                        _vm.comment.message || _vm.comment.text
                      )
                    ),
                  },
                }),
              ]),
              _vm.comment.attachment
                ? _c("div", { staticClass: "attachment" }, [
                    _c("img", {
                      attrs: { src: _vm.comment.attachment.media.image.src },
                    }),
                  ])
                : _vm._e(),
              _vm.page.network == "linkedin"
                ? _c(
                    "div",
                    { staticClass: "date-linkedin" },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.dateFormat(_vm.comment.created_time),
                            position: "top",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.dateFromNow(_vm.comment.created_time))
                            ),
                          ]),
                          _vm._v("\n           \n        "),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.page.network != "instagram"
                ? _c(
                    "div",
                    { staticClass: "more" },
                    [
                      _c(
                        "vs-dropdown",
                        { attrs: { "vs-trigger-click": true } },
                        [
                          _c("vs-button", {
                            staticClass: "btn-filter",
                            attrs: { type: "filled", icon: "more_horiz" },
                          }),
                          _c(
                            "vs-dropdown-menu",
                            [
                              (_vm.page.network == "facebook" &&
                                _vm.comment.can_hide == 1 &&
                                typeof _vm.comment.is_hidden != "undefined") ||
                              (_vm.page.network == "instagram" &&
                                _vm.page.name != _vm.comment.from.name)
                                ? _c(
                                    "vs-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.hideComment(
                                            _vm.comment.id,
                                            _vm.comment.is_hidden
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            !_vm.inbox || !_vm.inbox.hide
                                              ? _vm.$t(
                                                  "dash.button.hide.comment"
                                                )
                                              : _vm.$t(
                                                  "dash.button.unhide.comment"
                                                )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "vs-dropdown-item",
                                {
                                  staticClass: "delete-comment",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.deleteComment(_vm.comment.id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("dash.button.delete.comment")
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm.comment.is_hidden == 0 &&
                              !["instagram", "linkedin"].includes(
                                _vm.page.network
                              ) &&
                              !_vm.inbox
                                ? _c(
                                    "vs-dropdown-item",
                                    {
                                      staticClass: "delete-comment",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.blockUser(_vm.comment.from)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("dash.button.block.comment")
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.page.network == "instagram"
                ? _c(
                    "div",
                    { staticClass: "more" },
                    [
                      _c(
                        "vs-dropdown",
                        { attrs: { "vs-trigger-click": true } },
                        [
                          _c("vs-button", {
                            staticClass: "btn-filter",
                            attrs: { type: "filled", icon: "more_horiz" },
                          }),
                          _c(
                            "vs-dropdown-menu",
                            [
                              (_vm.page.network == "facebook" &&
                                _vm.comment.can_hide == 1 &&
                                typeof _vm.comment.is_hidden != "undefined") ||
                              (_vm.page.network == "instagram" &&
                                _vm.page.name != _vm.comment.from.username)
                                ? _c(
                                    "vs-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.hideComment(
                                            _vm.comment.id,
                                            _vm.comment.is_hidden ||
                                              _vm.comment.hidden
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            !_vm.inbox || !_vm.inbox.hide
                                              ? _vm.$t(
                                                  "dash.button.hide.comment"
                                                )
                                              : _vm.$t(
                                                  "dash.button.unhide.comment"
                                                )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "vs-dropdown-item",
                                {
                                  staticClass: "delete-comment",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.deleteComment(_vm.comment.id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t("dash.button.delete.comment")
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm.comment.is_hidden == 0 &&
                              !["instagram", "linkedin"].includes(
                                _vm.page.network
                              ) &&
                              !_vm.inbox
                                ? _c(
                                    "vs-dropdown-item",
                                    {
                                      staticClass: "delete-comment",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.blockUser(_vm.comment.from)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("dash.button.block.comment")
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              class: _vm.getLinkedin
                ? "cta-linkedin"
                : _vm.getInstagram
                ? "cta-instagram"
                : "cta",
            },
            [
              _c(
                "div",
                {
                  staticClass: "like",
                  class: [{ already: _vm.has_liked }],
                  on: {
                    click: function ($event) {
                      !_vm.has_liked && _vm.page.network != "instagram"
                        ? _vm.likeComment()
                        : ""
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.getCountLikes) +
                      _vm._s(_vm.$t("dash.label.fb.like"))
                  ),
                ]
              ),
              _vm.page.network == "linkedin"
                ? _c("div", {
                    staticStyle: {
                      height: "16px",
                      "border-left": "1px solid",
                      color: "#56687a",
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "answer",
                  on: {
                    click: function ($event) {
                      _vm.showInputComment = !_vm.showInputComment
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("dash.label.fb.answer")))]
              ),
              _vm.page.network == "linkedin" && _vm.comment.comment_count
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#56687a",
                        "padding-left": "0px !important",
                        "padding-right": "4px !important",
                      },
                    },
                    [_vm._v("·")]
                  )
                : _vm._e(),
              _vm.comment.comment_count && _vm.page.network == "linkedin"
                ? _c("div", { staticClass: "linkedin-comments-count" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.comment.comment_count) +
                        " " +
                        _vm._s(_vm.$t("dash.label.fb.comments")) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _vm.page.network != "linkedin" && _vm.page.network != "instagram"
                ? _c(
                    "div",
                    { staticClass: "date" },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.dateFormat(_vm.comment.created_time),
                            position: "top",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.dateFromNow(_vm.comment.created_time))
                            ),
                          ]),
                          _vm._v("\n           \n        "),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.page.network == "instagram"
                ? _c(
                    "div",
                    { staticClass: "date-instagram" },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.dateFormat(_vm.comment.created_time),
                            position: "top",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.dateFromNow(_vm.comment.created_time))
                            ),
                          ]),
                          _vm._v("\n         \n      "),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm.showInputComment
            ? _c(
                "div",
                { staticClass: "message" },
                [
                  _c("message-comment", {
                    attrs: {
                      node: _vm.comment,
                      page: _vm.page,
                      inbox: _vm.inbox,
                    },
                    on: {
                      getComments: _vm.getComments,
                      onSubmitComment: _vm.onSubmitComment,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          (_vm.comment.comments || _vm.comment.replies) &&
          (_vm.comment.comments || _vm.comment.replies).data &&
          (_vm.comment.comments || _vm.comment.replies).data.length &&
          !_vm.badWordsFeed
            ? _c(
                "ul",
                { style: { width: _vm.getLinkedin ? "130%" : "100%" } },
                _vm._l(
                  (_vm.comment.comments || _vm.comment.replies).data,
                  function (item, key) {
                    return _c(
                      "li",
                      { key: key, class: `comment-${key}` },
                      [
                        _c("comment", {
                          attrs: {
                            comment: item,
                            page: _vm.page,
                            inbox: _vm.inbox,
                          },
                          on: {
                            delete: _vm.deleteComment,
                            hide: _vm.hideComment,
                            block: _vm.blockUser,
                            likeComment: _vm.likeCommentEvent,
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }